import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, Info, Shield, LifeBuoy, FileText, Sparkles } from 'lucide-react';

const Footer: React.FC = () => {
  const { t } = useTranslation('translation');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-brand-dark/80 backdrop-blur-md border-t border-white/5 py-3 lg:py-4 px-6 mt-auto relative z-20">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
        {/* Left Side: Logo + Brand + Copyright */}
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2.5">
            <div className="w-7 h-7 bg-gradient-to-br from-purple-500 to-blue-500 rounded-lg flex items-center justify-center font-bold text-white text-[10px] shadow-lg shadow-purple-500/20">V</div>
            <span className="font-bold text-lg text-white tracking-tighter">{t('common.brand_name')}</span>
          </div>
          <div className="h-4 w-[1px] bg-white/10 hidden sm:block" />
          <div className="flex items-center gap-2 text-gray-500 text-[10px] font-medium hidden sm:flex">
            <span>&copy; {currentYear} {t('footer.rights')}</span>
            <span className="text-white/10">•</span>
            <span className="opacity-80">{t('footer.made_with')}</span>
          </div>
        </div>

        {/* Right Side: Links */}
        <nav className="flex items-center gap-4 md:gap-8">
          {/* Navigation Links */}
          <div className="flex items-center gap-4 md:gap-6">
            <Link to="/" title={t('footer.credits_spending')} className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-[11px] font-medium">
              <LayoutDashboard className="w-4 h-4 text-purple-400 group-hover:scale-110 transition-transform" />
              <span className="hidden lg:inline">{t('footer.credits_spending')}</span>
            </Link>
            <Link to="/about" title={t('footer.about_us')} className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-[11px] font-medium">
              <Info className="w-4 h-4 text-blue-400 group-hover:scale-110 transition-transform" />
              <span className="hidden lg:inline">{t('footer.about_us')}</span>
            </Link>
            <Link to="/" title={t('footer.how_to_pin')} className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-[11px] font-medium">
              <Sparkles className="w-4 h-4 text-yellow-400 group-hover:scale-110 transition-transform" />
              <span className="hidden lg:inline">{t('footer.how_to_pin')}</span>
            </Link>
          </div>

          <div className="h-4 w-[1px] bg-white/10" />

          {/* Legal Links */}
          <div className="flex items-center gap-4 md:gap-6">
            <Link to="/privacy" title={t('footer.privacy')} className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-[11px] font-medium">
              <Shield className="w-4 h-4 text-green-400 group-hover:scale-110 transition-transform" />
              <span className="hidden lg:inline">{t('footer.privacy')}</span>
            </Link>
            <Link to="/terms" title={t('footer.terms')} className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-[11px] font-medium">
              <FileText className="w-4 h-4 text-blue-400 group-hover:scale-110 transition-transform" />
              <span className="hidden lg:inline">{t('footer.terms')}</span>
            </Link>
            <a href="mailto:songokumbl@gmail.com" title={t('footer.support')} className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-[11px] font-medium">
              <LifeBuoy className="w-4 h-4 text-orange-400 group-hover:scale-110 transition-transform" />
              <span className="hidden lg:inline">{t('footer.support')}</span>
            </a>
          </div>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
